export const aplicationStatuses = ["dormant", "in-review", "revising", "in-second-review", "released", "inquiring", "declined", "aborted", "uninterested", "expired", "successful"];

export const finishStatuses = ["declined", "aborted", "uninterested", "expired", "successful"];

export const statusesToAccept = ["pending", "in-sync"];

// export const searchKeys = ["name", "status", "applicationNumber","type", "recruitCompany", "firstName", "lastName"];

export const path = process.env.REACT_APP_RECRUITMENT;

export const IMAGE_FILETYPES = ["image/jpeg", "image/png", "image/jpeg", "image/bmp", "image/tiff", "image/gif"];

export const APPLICATION_EDITOR_INQUIRY = [
    "inquiry-identification-identity-card-back-erroneous",
    "inquiry-identification-identity-card-front-erroneous",
    "inquiry-identification-identity-card-expired",
    "inquiry-identification-identity-card-missing-residence",
    "inquiry-identification-identity-card-bad-quality",
    "inquiry-identification-identity-card-shareholder-missing",
    "inquiry-identification-business-regulation-missing",
    "inquiry-identification-commercial-register-missing",
    "inquiry-identification-other-verification-missing",
    "inquiry-identification-european-other-verification-missing",
    "inquiry-bank-details-signature-deviating-account-owner",
    "inquiry-finalize-signature-missing",
    "inquiry-finalize-company-signature-missing",
    "inquiry-finalize-spouse-signature-missing",
    "inquiry-finalize-signature-on-behalf-of-prohibited",
    "inquiry-base-data-name-erroneous",
    "inquiry-base-data-birthdate",
    "inquiry-base-data-deviating-surname-verification-missing",
    "inquiry-general-see-email"
];

export const mb = 2097152;

// One byte = 1 character.
//
// 1 kilobyte = 1024 bytes = 1024 characters.
//
// 1 megabyte = 1024 kilobytes = 1,048,576 bytes = 1,048,576 characters.
//
// 2 megabytes = 2×1,048,576 bytes = 2,097,152 bytes = 2,097,152 characters.